import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useApp } from "@/context/AppContext";

export function PasswordInput({
  value,
  onChange,
  testid,
  autoComplete = "current-password",
  required = true,
  placeholder = "",
}) {
  const { t } = useApp();
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        data-testid={testid}
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        required={required}
        placeholder={placeholder}
        className="focusable w-full px-4 py-3 pr-12 rounded-lg bg-[#141414] border border-[#D21F2A]/20 text-[#FFFFFF]"
      />
      <button
        type="button"
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? t("pw_hide") : t("pw_show")}
        aria-pressed={show}
        title={show ? t("pw_hide") : t("pw_show")}
        className="focusable absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded text-[#9AA0A6] hover:text-[#FFFFFF] transition-colors"
      >
        {show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
      </button>
    </div>
  );
}
